import type { AxiosError } from "axios";

import { refreshAuth } from "~/api/auth";
import { useToastStore } from "~/components/Shared/Toast/toastStore";
import { useUserStore } from "~/stores";
import { api } from "../axios";

// interceptor was based on this article
// https://dev.to/franciscomendes10866/how-to-use-axios-interceptors-b7d
export const errorResponseInterceptor = async (error: AxiosError) => {
  const originalRequest = error.config;

  // Prevent infinite refresh loop
  let isRefreshRequest = false;
  if (
    originalRequest?.params &&
    typeof originalRequest.params === "object" &&
    originalRequest.params !== null &&
    Object.prototype.hasOwnProperty.call(
      originalRequest.params,
      "_isRefreshRequest",
    )
  ) {
    isRefreshRequest = Boolean(
      (originalRequest.params as { _isRefreshRequest?: unknown })
        ._isRefreshRequest,
    );
  }
  if (isRefreshRequest) {
    useUserStore.getState().logout();
    void useToastStore.getState().pushToast({
      type: "error",
      title: "Session Expired",
      message: "Your session has expired. Please log in again.",
    });
    return Promise.reject(error);
  }

  if (originalRequest && error.response?.status === 401) {
    const { accessToken, setAuth, logout } = useUserStore.getState();

    if (!accessToken) {
      logout();
      return Promise.reject(error);
    }

    try {
      const authResponse = await refreshAuth();
      setAuth(authResponse);

      if (originalRequest.headers) {
        originalRequest.headers.Authorization = `Bearer ${authResponse.accessToken}`;
      }

      return api(originalRequest);
    } catch (e) {
      logout();
      void useToastStore.getState().pushToast({
        type: "error",
        title: "Session Expired",
        message: "Your session has expired. Please log in again.",
      });
      if (e instanceof Error) {
        return Promise.reject(e);
      }
      return Promise.reject(
        new Error("An unknown error occurred during token refresh."),
      );
    }
  }

  return Promise.reject(error);
};
